<template>
  <div class="content-wrapper">
    <app-breadcrumb
      :page-title="$t('No conformidades')"
      :directory="$t('evaluación')"
      :icon="'trello'"
    />

    <div class="mb-primary">
      <div class="d-flex justify-content-between mb-3">
      </div>
      <app-tab :tabs="tabsHorizontal" type="horizontal" />
    </div>
    
  </div>
</template>


<script>

export default {
  name: "Tabs",
  data() {
    return {
      icon: "settings",
      tabsHorizontal: [
        {
          icon: "corner-up-right",
          name: "Elaborar y enviar resolución de acreditación",
          component: "",
          permission: "",
        },
        {
          icon: "activity",
          name: "Enviar proforma de certificado",
          component: "",
          permission: "",
        },
        {
          icon: "activity",
          name: "Revisión borrador certificado de acreditación",
          component: "",
          permission: "",
        },
        {
          icon: "activity",
          name: "Publicación WEB del alcance",
          component: "",
          permission: "",
        },
        {
          icon: "inbox",
          name: "Entrega certificado de accreditación",
          component: "",
          permission: "",
        },

      ],
      
    };
  },
};
</script>
